import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { RushModeEnum } from '@core/enums'
import { BetService, RushGameService } from '@rush-shared/services'
import { FormsModule } from '@angular/forms'
import { AccountService, WebSocketService } from '@core/services'
import { BetOptionModel } from '@rush-shared/models'
import { BetTypeEnum } from '@shared/enums'
import { TwoDigitDecimalNumberDirective } from '@shared/directives'

@Component({
  selector: 'app-bet-section',
  standalone: true,
  imports: [CommonModule, FormsModule, TwoDigitDecimalNumberDirective],
  templateUrl: './bet-section.component.html',
  styleUrl: './bet-section.component.sass',
})
export class BetSectionComponent implements OnInit {
  coinsValue = [
    { text: '1', fontSize: 'text-lg', value: 1 },
    { text: '5', fontSize: 'text-lg', value: 5 },
    { text: '20', fontSize: 'text-lg', value: 20 },
    { text: '50', fontSize: 'text-lg', value: 50 },
    { text: '100', fontSize: 'text-base', value: 100 },
    { text: '200', fontSize: 'text-base', value: 200 },
    { text: '500', fontSize: 'text-base', value: 500 },
    { text: '1K', fontSize: 'text-lg', value: 1000 },
    { text: '5K', fontSize: 'text-lg', value: 5000 },
    { text: '10K', fontSize: 'text-base', value: 10000 },
  ]

  betOptions = [
    { label: 'call', multiplier: 2, percentage: 100 },
    { label: 'pair', multiplier: 5, percentage: 400 },
    { label: 'trio', multiplier: 10, percentage: 1900 },
  ]

  constructor(
    public _betService: BetService,
    public _accountService: AccountService,
    private _webSocketService: WebSocketService,
  ) {}

  ngOnInit(): void {
    this._webSocketService.listenToRushMode(({ mode }) => {
      if (mode === RushModeEnum.DealClosed) {
        if (this._betService.betValue) this._betService.betValue = undefined
      }
    })
  }

  onEasyPickClick(value: number): void {
    this._betService.betValue = value
  }

  placeBet(bet: BetOptionModel): void {
    if (this._betService.betValue && this._betService.betValue > 0) {
      this._betService.updateBet(bet.type, this._betService.betValue)
      this._betService.betValue = undefined
    }
  }

  isBetPlaced(type: BetTypeEnum): boolean {
    const bet = this._betService.getBet(type)
    return bet ? bet.total > 0 : false
  }

  disableBet(index: number) {
    if (!this._betService.betValue || this._betService.betValue <= 0) {
      return true
    }

    const grandTotalBet = this._betService.betValue + this._betService.betGrandTotal
    const currentTotalBet =
      this._betService.betValue + (this._betService.playerBets[index]?.total || 0)

    if (grandTotalBet > this._accountService.currentChips) return true

    const maxBet = this._betService.betOptions[index].maxBet

    if (currentTotalBet > maxBet) return true

    return false
  }
}
